export default defineNuxtPlugin(async nuxtApp => {
    const runtimeConfigs = useRuntimeConfig()
    const playersOnline = useState('playersOnline', () => 0)
    const openingDate = useState('openingDate', () => null)
    const facebookLink = useState('facebookLink', () => null)
    const instagramLink = useState('instagramLink', () => null)
    const youtubeLink = useState('youtubeLink', () => null)

    const fetchData = async () => {
        try {
            const { data: data } = await useFetch(`${runtimeConfigs.public.API_URL}/api/settings/basic`)
            
            playersOnline.value = data.value?.online || 0
            openingDate.value = data.value?.opening_date || null
            facebookLink.value = data.value?.facebook_link || null
            instagramLink.value = data.value?.instagram_link || null
            youtubeLink.value = data.value?.youtube_link || null
            
            // Se data.value for um array, usa reduce, senão usa o objeto diretamente
            const settingsObject = Array.isArray(data?.value) 
                ? data.value.reduce((acc, item) => {
                    acc[item.key] = item.value
                    return acc
                }, {})
                : (data?.value || {})
            
            console.log(settingsObject)
            nuxtApp.$settings = settingsObject
        } catch (error) {
            console.log('Houve um erro ao carregar as configurações do site.')
            console.log(error)

            const defaultSettings = {
                general_site_logo: "loading.png",
                general_site_title: "SER",
                general_site_color: '#f7bf07',
                maintence: true,
            }

            nuxtApp.$settings = defaultSettings
        }
    }

    await fetchData()
    setInterval(fetchData, 60000)
})
